module.exports = function() {
  return new Worker(__webpack_public_path__ + "5dc30347da0c531a04ad.worker.js");
};